import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { composeStoreInitializer } from '@beef/redux';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { NewsDetailsPage } from 'pages/News/NewsDetails/types';

const rootReducer = combineReducers({
  data: (state = {}) => state,
  renderUrl: (state = '/') => state,
  baseUrl: (state = '/') => state,
});

export const initializeStore = composeStoreInitializer(
  rootReducer,
) as unknown as typeof configureStore<typeof rootReducer>;

export type RootState = {
  data: NewsDetailsPage;
};
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
